import { components } from 'react-select';
import React from 'react';
import { alpha, Box, Stack } from '@mui/material';
import { FormComponentValue } from 'components/common/form/layout/control';
import Checkbox from '@mui/material/Checkbox/Checkbox';

// Default template for Option, override with props.optionComponent
export const ReactSelectOption = (props: any) => {
    const dataTest = `${props.selectProps?.['data-test']}_option`;

    const isCheckbox: boolean = props.selectProps?.isCheckbox ?? false;
    const value: FormComponentValue = props.data;
    const desc = value.props?.desc;
    const descRight = value.props?.desc_right;

    return (
        <Box data-test={dataTest}>
            <components.Option {...props}>
                <Stack direction={'row'}>
                    {props.data?.props?.displayIcon !== false && props.data.icon && (
                        <Box
                            sx={{
                                mr: 1,
                                width: '16px',
                                height: '16px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                pt: '1px',
                                '.svg-icon-mi': { fontSize: '16px' },
                                '.svg-inline--fa': { fontSize: '14px' },
                                img: {
                                    maxWidth: '100%',
                                    maxHeight: '100%',
                                },
                            }}
                        >
                            {props.data.icon}
                        </Box>
                    )}
                    <Stack flexGrow={1} sx={{ minWidth: 0 }}>
                        <Box sx={{ '.MuiCheckbox-root': { p: 0, mr: 1, verticalAlign: 'top' } }}>
                            {isCheckbox && <Checkbox checked={props.isSelected} />}
                            {props.children}
                        </Box>
                        {desc && (
                            <Box sx={{ pt: '2px', color: (theme) => alpha(theme.palette.text.primary, 0.8) }}>
                                {desc}
                            </Box>
                        )}
                    </Stack>
                    {descRight && (
                        <Box sx={{ pl: 1, color: (theme) => alpha(theme.palette.text.primary, 0.64) }} flexShrink={0}>
                            {descRight}
                        </Box>
                    )}
                </Stack>
            </components.Option>
        </Box>
    );
};
